// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder_placeholder__wBw+1","dark":"placeholder_dark__jd6PF","animated":"placeholder_animated__6yIHo","loading":"placeholder_loading__ztDlI"};